import { EventEmitter } from 'fbemitter';

const emitter = new EventEmitter();
// let userName = '';
let scrollDirection = false;
let lastScrollPos = false;
let menuHeights = [];
let selectedSubMenu = false;
let searchTerm = false;
let searchResults = false;

const PageInfoStore = {
  setMenuHeights(handle, height) {
    menuHeights[handle] = height;
    emitter.emit('menuHeights');
  },

  getMenuHeights() { return menuHeights },

  setSelectedSubMenu(handle) {
    selectedSubMenu = handle;
    emitter.emit('selectedSubMenu');
  },

  getSelectedSubMenu() { return selectedSubMenu; },

  setSearchTerm(inputValue) {
    searchTerm = inputValue;
    emitter.emit('searchValue');
  },
  getSearchTerm() { return searchTerm; },

  setSearchResults(results) {
    searchResults = results;
    emitter.emit('searchResults');
  },
  getSearchResults() { return searchResults; },

  setLastScrollPos(position) {
    lastScrollPos = position;
  },

  getLastScrollPos() {
    return lastScrollPos;
  },

  setScrollDirection(currentPos) {
    // console.log(`last: ${lastScrollPos}, curr: ${currentPos}`);
    if (lastScrollPos && currentPos) {
      lastScrollPos < currentPos ? scrollDirection = 'down' : scrollDirection = 'up';
      emitter.emit('scrollDirection');
    }
  },

  getScrollDirection() { return scrollDirection },

  addListener(eventType: string, fn: Function) {
    return emitter.addListener(eventType, fn);
  },
};

export default PageInfoStore;
